import { ActivityTagsResponse } from "@/pages/settings/components/activities/types";
import { Activity } from "@/entities/activities/types";
import useAPI from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";

export const useActivityTags = (
  activityType: Activity,
  enabled = true
): ExtendedUseQueryResult<ActivityTagsResponse> => {
  return useAPI(
    "settings/activities/tags",
    {
      pathParams: { activityType: activityType.toString() }
    },
    { enabled }
  );
};
